import { Grid } from '@material-ui/core';
import React, { useCallback, useEffect, useState } from 'react';
import { useAuth } from '../../../../../../hooks/auth';
import { StatusSaleButton } from '../../../../../Produtos/components/styles';
import {
  ButtonStyled,
  InformativeSpan,
  PageSubtitle,
  PageTitle,
  Wrapper,
} from '../../styles';
import api from '../../../../../../services/api';
import { useToast } from '../../../../../../hooks/toast';

const ScheduledDelivery: React.FC = () => {
  const { user } = useAuth();
  const { addToast } = useToast();

  const [scheduledDelivery, setScheduledDelivery] = useState(false);
  const [consumptionOnSite, setConsumptionOnSite] = useState(false);
  const [withdrawEnabled, setWithdrawEnabled] = useState(false);
  const [deliveryEnabled, setDeliveryEnabled] = useState(false);
  const [parametersSavedStatus, setParametersSavedStatus] = useState({
    withdrawEnabled: false,
    deliveryEnabled: false,
  });

  const handleSubmitScheduledDelivery = useCallback(async () => {
    try {
      await api.post(`/parametro`, {
        descricao: 'entrega_agendada',
        empresa_id: user.empresa_id,
        role: JSON.stringify({
          status: scheduledDelivery,
        }),
      });

      addToast({
        title: `Alterações feitas com sucesso!`,
        type: 'success',
      });
    } catch (err) {
      addToast({
        title: 'Algo deu errado',
        type: 'error',
        description: (err as any).response?.data?.message || 'Tente novamente.',
      });
    }
  }, [scheduledDelivery, user, addToast]);

  const handleSubmitConsumptionOnSite = useCallback(async () => {
    try {
      await api.post(`/parametro`, {
        descricao: 'consumo_local',
        empresa_id: user.empresa_id,
        role: JSON.stringify({
          status: consumptionOnSite,
        }),
      });

      addToast({
        title: `Alterações feitas com sucesso!`,
        type: 'success',
      });
    } catch (err) {
      addToast({
        title: 'Algo deu errado',
        type: 'error',
        description: (err as any).response?.data?.message || 'Tente novamente.',
      });
    }
  }, [consumptionOnSite, user, addToast]);

  const handleSubmitWithdrawEnabled = useCallback(async () => {
    try {
      await api.post(`/parametro`, {
        descricao: 'withdraw_enabled',
        empresa_id: user.empresa_id,
        role: JSON.stringify({
          status: withdrawEnabled,
        }),
      });

      setParametersSavedStatus((state) => {
        return {...state, withdrawEnabled: withdrawEnabled };
      });

      if(consumptionOnSite && !withdrawEnabled) {
        await api.post(`/parametro`, {
          descricao: 'consumo_local',
          empresa_id: user.empresa_id,
          role: JSON.stringify({
            status: false,
          }),
        });

        setConsumptionOnSite(false);
      }

      addToast({
        title: `Alterações feitas com sucesso!`,
        type: 'success',
      });
    } catch (err) {
      addToast({
        title: 'Algo deu errado',
        type: 'error',
        description: (err as any).response?.data?.message || 'Tente novamente.',
      });
    }
  }, [withdrawEnabled, user, addToast]);

  const handleSubmitDeliveryEnabled = useCallback(async () => {
    try {
      await api.post(`/parametro`, {
        descricao: 'delivery_enabled',
        empresa_id: user.empresa_id,
        role: JSON.stringify({
          status: deliveryEnabled,
        }),
      });

      setParametersSavedStatus((state) => {
        return {...state, deliveryEnabled: deliveryEnabled };
      });

      addToast({
        title: `Alterações feitas com sucesso!`,
        type: 'success',
      });
    } catch (err) {
      addToast({
        title: 'Algo deu errado',
        type: 'error',
        description: (err as any).response?.data?.message || 'Tente novamente.',
      });
    }
  }, [deliveryEnabled, user, addToast]);

  useEffect(() => {
    async function loadScheduledDelivery(): Promise<void> {
      try {
        const response = await api.get('/parametro', {
          params: {
            descricao: 'entrega_agendada',
            empresa_id: user.empresa_id,
          },
        });

        if (response.data) {
          const role = JSON.parse(response.data.role);

          setScheduledDelivery(role.status);
        }
      } catch (err) {
        addToast({
          title: 'Algo deu errado',
          type: 'error',
          description:
            (err as any).response?.data?.message || 'Tente novamente.',
        });
      }
    }

    async function loadConsumptionOnSite(): Promise<void> {
      try {
        const response = await api.get('/parametro', {
          params: {
            descricao: 'consumo_local',
            empresa_id: user.empresa_id,
          },
        });

        if (response.data) {
          const role = JSON.parse(response.data.role);

          setConsumptionOnSite(role.status);
        }
      } catch (err) {
        addToast({
          title: 'Algo deu errado',
          type: 'error',
          description:
            (err as any).response?.data?.message || 'Tente novamente.',
        });
      }
    }

    async function loadWithdrawEnabled(): Promise<void> {
      try {
        const response = await api.get('/parametro', {
          params: {
            descricao: 'withdraw_enabled',
            empresa_id: user.empresa_id,
          },
        });

        if (response.data) {
          const role = JSON.parse(response.data.role);
          setWithdrawEnabled(role.status);
          setParametersSavedStatus((state) => {
            return {...state, withdrawEnabled: role.status };
          });
        } else {
          setWithdrawEnabled(true);
          setParametersSavedStatus((state) => {
            return {...state, withdrawEnabled: true };
          });
        }
      } catch (err) {
        addToast({
          title: 'Algo deu errado',
          type: 'error',
          description:
            (err as any).response?.data?.message || 'Tente novamente.',
        });
      }
    }

    async function loadDeliveryEnabled(): Promise<void> {
      try {
        const response = await api.get('/parametro', {
          params: {
            descricao: 'delivery_enabled',
            empresa_id: user.empresa_id,
          },
        });

        if (response.data) {
          const role = JSON.parse(response.data.role);
          setDeliveryEnabled(role.status);
          setParametersSavedStatus((state) => {
            return {...state, deliveryEnabled: role.status };
          });
        } else {
          setDeliveryEnabled(true);
          setParametersSavedStatus((state) => {
            return {...state, deliveryEnabled: true };
          });
        }
      } catch (err) {
        addToast({
          title: 'Algo deu errado',
          type: 'error',
          description:
            (err as any).response?.data?.message || 'Tente novamente.',
        });
      }
    }

    loadScheduledDelivery();
    loadConsumptionOnSite();
    loadWithdrawEnabled();
    loadDeliveryEnabled();
  }, [user.empresa_id, addToast]);

  return (
    <Wrapper style={{ paddingLeft: 50, paddingRight: 50 }}>
      <Grid container spacing={3} style={{ marginTop: 30 }}>
        <Grid item xs={12}>
          <PageTitle className="main__title">Opções de Entrega</PageTitle>

          <PageSubtitle>Entrega agendada</PageSubtitle>

          <InformativeSpan style={{ paddingTop: 10, maxWidth: 800 }}>
            Ao habilitar a entrega agendada os pedidos poderão ser programados
            com data e hora desejada.
          </InformativeSpan>
          <Grid
            container
            justify="center"
            style={{ display: 'block', paddingBottom: 15, paddingTop: 30 }}
          >
            <Grid
              item
              lg={4}
              md={6}
              xs={12}
              style={{ marginLeft: 15, maxWidth: 160 }}
            >
              <span>Habilitado:</span>

              <div
                style={{
                  marginTop: 8,
                  display: 'flex',
                  justifyContent: 'flex-start',
                  alignItems: 'flex-end',
                  height: 'inherit',
                }}
              >
                <div
                  onClick={(event) => event.stopPropagation()}
                  onFocus={(event) => event.stopPropagation()}
                >
                  <StatusSaleButton
                    type="button"
                    isPaused={scheduledDelivery}
                    className="paused"
                    onClick={() => setScheduledDelivery(false)}
                  >
                    Desabilitado
                  </StatusSaleButton>

                  <StatusSaleButton
                    type="button"
                    isPaused={!scheduledDelivery}
                    className="activated"
                    onClick={() => setScheduledDelivery(true)}
                  >
                    Habilitado
                  </StatusSaleButton>
                </div>
              </div>
            </Grid>
            <Grid item xs={12}>
              <Grid container justify="center" style={{ paddingTop: 30 }}>
                <Grid item lg={4} md={6} xs={12}>
                  <ButtonStyled
                    type="button"
                    onClick={handleSubmitScheduledDelivery}
                  >
                    Salvar
                  </ButtonStyled>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <PageSubtitle>Consumo no local</PageSubtitle>
          <InformativeSpan style={{ paddingTop: 10, maxWidth: 800 }}>
            Ao habilitar o consumo no local, os clientes terão a opção de
            consumir no estabelecimento.
          </InformativeSpan>
          <Grid
            container
            justify="center"
            style={{ display: 'block', paddingBottom: 60, paddingTop: 30 }}
          >
            <Grid
              item
              lg={4}
              md={6}
              xs={12}
              style={{ marginLeft: 15, maxWidth: 160 }}
            >
              <span>Habilitado:</span>

              <div
                style={{
                  marginTop: 8,
                  display: 'flex',
                  justifyContent: 'flex-start',
                  alignItems: 'flex-end',
                  height: 'inherit',
                }}
              >
                <div
                  onClick={(event) => event.stopPropagation()}
                  onFocus={(event) => event.stopPropagation()}
                  title={
                    !parametersSavedStatus.withdrawEnabled
                      ? 'Não é possível habilitar consumo no local enquanto a retirada está desativada'
                      : ''
                  }
                >
                  <StatusSaleButton
                    type="button"
                    isPaused={consumptionOnSite}
                    className="paused"
                    onClick={() => setConsumptionOnSite(false)}
                    disabled={!parametersSavedStatus.withdrawEnabled}
                  >
                    Desabilitado
                  </StatusSaleButton>

                  <StatusSaleButton
                    type="button"
                    isPaused={!consumptionOnSite}
                    className="activated"
                    onClick={() => setConsumptionOnSite(true)}
                    disabled={!parametersSavedStatus.withdrawEnabled}
                  >
                    Habilitado
                  </StatusSaleButton>
                </div>
              </div>
            </Grid>
            <Grid item xs={12}>
              <Grid container justify="center" style={{ paddingTop: 30 }}>
                <Grid item lg={4} md={6} xs={12}>
                  <ButtonStyled
                    type="button"
                    onClick={handleSubmitConsumptionOnSite}
                    disabled={!parametersSavedStatus.withdrawEnabled}
                    title={
                      !parametersSavedStatus.withdrawEnabled
                        ? 'Não é possível habilitar consumo no local enquanto a retirada está desativada'
                        : ''
                    }
                  >
                    Salvar
                  </ButtonStyled>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <PageSubtitle>Retirada</PageSubtitle>
          <InformativeSpan style={{ paddingTop: 10, maxWidth: 800 }}>
            Ao habilitar a retirada, os clientes poderão selecionar retirada
            como método de envio.
          </InformativeSpan>
          <Grid
            container
            justify="center"
            style={{ display: 'block', paddingBottom: 60, paddingTop: 30 }}
          >
            <Grid
              item
              lg={4}
              md={6}
              xs={12}
              style={{ marginLeft: 15, maxWidth: 160 }}
            >
              <span>Habilitado:</span>

              <div
                style={{
                  marginTop: 8,
                  display: 'flex',
                  justifyContent: 'flex-start',
                  alignItems: 'flex-end',
                  height: 'inherit',
                }}
              >
                <div
                  onClick={(event) => event.stopPropagation()}
                  onFocus={(event) => event.stopPropagation()}
                  title={
                    !parametersSavedStatus.deliveryEnabled
                      ? 'Não é possível desabilitar a retirada enquanto o delivery está desativado'
                      : ''
                  }
                >
                  <StatusSaleButton
                    type="button"
                    isPaused={withdrawEnabled}
                    className="paused"
                    onClick={() => setWithdrawEnabled(false)}
                    disabled={!parametersSavedStatus.deliveryEnabled}
                  >
                    Desabilitado
                  </StatusSaleButton>

                  <StatusSaleButton
                    type="button"
                    isPaused={!withdrawEnabled}
                    className="activated"
                    onClick={() => setWithdrawEnabled(true)}
                    disabled={!parametersSavedStatus.deliveryEnabled}
                  >
                    Habilitado
                  </StatusSaleButton>
                </div>
              </div>
            </Grid>
            <Grid item xs={12}>
              <Grid container justify="center" style={{ paddingTop: 30 }}>
                <Grid item lg={4} md={6} xs={12}>
                  <ButtonStyled
                    type="button"
                    onClick={handleSubmitWithdrawEnabled}
                    disabled={!parametersSavedStatus.deliveryEnabled}
                    title={
                      !parametersSavedStatus.deliveryEnabled
                        ? 'Não é possível desabilitar a retirada enquanto o delivery está desativado'
                        : ''
                    }
                  >
                    Salvar
                  </ButtonStyled>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <PageSubtitle>Delivery</PageSubtitle>
          <InformativeSpan style={{ paddingTop: 10, maxWidth: 800 }}>
            Ao habilitar o delivery, os clientes poderão selecionar
            delivery/envio como método de envio.
          </InformativeSpan>
          <Grid
            container
            justify="center"
            style={{ display: 'block', paddingBottom: 60, paddingTop: 30 }}
          >
            <Grid
              item
              lg={4}
              md={6}
              xs={12}
              style={{ marginLeft: 15, maxWidth: 160 }}
            >
              <span>Habilitado:</span>

              <div
                style={{
                  marginTop: 8,
                  display: 'flex',
                  justifyContent: 'flex-start',
                  alignItems: 'flex-end',
                  height: 'inherit',
                }}
              >
                <div
                  onClick={(event) => event.stopPropagation()}
                  onFocus={(event) => event.stopPropagation()}
                  title={
                    !parametersSavedStatus.withdrawEnabled
                      ? 'Não é possível desabilitar o delivery enquanto a retirada está desativada'
                      : ''
                  }
                >
                  <StatusSaleButton
                    type="button"
                    isPaused={deliveryEnabled}
                    className="paused"
                    onClick={() => setDeliveryEnabled(false)}
                    disabled={!parametersSavedStatus.withdrawEnabled}
                  >
                    Desabilitado
                  </StatusSaleButton>

                  <StatusSaleButton
                    type="button"
                    isPaused={!deliveryEnabled}
                    className="activated"
                    onClick={() => setDeliveryEnabled(true)}
                    disabled={!parametersSavedStatus.withdrawEnabled}
                  >
                    Habilitado
                  </StatusSaleButton>
                </div>
              </div>
            </Grid>
            <Grid item xs={12}>
              <Grid container justify="center" style={{ paddingTop: 30 }}>
                <Grid item lg={4} md={6} xs={12}>
                  <ButtonStyled
                    type="button"
                    onClick={handleSubmitDeliveryEnabled}
                    disabled={!parametersSavedStatus.withdrawEnabled}
                    title={
                      !parametersSavedStatus.withdrawEnabled
                        ? 'Não é possível desabilitar o delivery enquanto a retirada está desativada'
                        : ''
                    }
                  >
                    Salvar
                  </ButtonStyled>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Wrapper>
  );
};

export default ScheduledDelivery;
